const StopIcon = ({ height = 14, width = 14 }) => (
  <svg
    fill="none"
    height={ height }
    width={ width }
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 0h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1Z"
      fill="#fff"
    />
  </svg>
);

export default StopIcon;
